
import { useEffect, useState } from "react";
import {
    CommonHeader,
    EmptyListPage,
    ErrorSuccessModal,
    TableLoader,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";

import { SearchIcon } from "../../../components/Icon";
import { EmptyList } from "../../../assets/images";
import useDebounce from "../../../customHooks/useDebounce";
import { checkUniqueDepartmentNameAction, createDepartmentAction, getDepartmentListAction, resetClientSettingsError, resetClientSettingsStatusCode, resetClientSettingsSuccess, resetDepartmentList, resetDepartmentMessage, resetDepartmentUniqueCheckFetching, resetDepartmentUniqueCheckMessage, updateDepartmentAction } from "../../../redux/clientSettings";
import AddEditDepartment from "./AddEditDepartment";
import DepartmentTable from "../../../components/ClientSettings/Department/DepartmentTable";
import { CreateDepartmentPayloadType, GetDepartmentListPayloadType, UniqueDepartmentNamePayloadType, UpdateDepartmentPayloadType } from "../../../commonTypes/clientSettingsTypes";
import { DepartmentListType } from "../../../redux/clientSettings/clientSettingTypes";

type AppProps = {
    history: any;
    fetching: boolean;
    message: string|null;
    success: null | number;
    error: null | string;
    statusCode: null | number;
    token: null | string;
    departmentList: DepartmentListType[]|[];
    departmentTotalCount: number;
    departmentUniqueCheckFetching:boolean
    departmentUniqueCheckMessage:string|null
    dispatchResetClientSettingsError:()=>void;
    dispatchResetSession: () => void;
    dispatchResetClientSettingsSuccessAction:()=>void;
    dispatchGetDepartmentList:(data:GetDepartmentListPayloadType)=>void
    dispatchResetDepartmentList:()=>void;
    dispatchResetClientSettingsStatusCode:()=>void;
    dispatchUpdateDepartmentAction:(data:UpdateDepartmentPayloadType)=>void;
    dispatchAddDepartmentAction:(data:CreateDepartmentPayloadType)=>void;
    dispatchResetDepartmentMessage:()=>void;
    dispatchCheckUniqueDepartmentNameAction:(data:UniqueDepartmentNamePayloadType)=>void;
    dispatchResetDepartmentUniqueCheckMessage:()=>void;
    dispatchResetDepartmentUniqueCheckFetching:()=>void;

   
};
const Department = ({
    history,
    fetching,
    message,
    success,
    error,
    token,
    statusCode,
    departmentList,
    departmentTotalCount,
    departmentUniqueCheckFetching,
    departmentUniqueCheckMessage,
    dispatchResetClientSettingsError,
    dispatchResetClientSettingsSuccessAction,
    dispatchGetDepartmentList,
    dispatchResetDepartmentList,
    dispatchResetClientSettingsStatusCode,
    dispatchUpdateDepartmentAction,
    dispatchAddDepartmentAction,
    dispatchResetSession,
    dispatchResetDepartmentMessage,
    dispatchCheckUniqueDepartmentNameAction,
    dispatchResetDepartmentUniqueCheckMessage,
    dispatchResetDepartmentUniqueCheckFetching

  
}: AppProps) => {
    const client_code = history?.location?.state?.client_code;
    const company_name = history?.location?.state?.company_name;

    const [showAddEditDepartmentModal, setShowAddEditDepartmentModal] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>("");
    const [departmentName, setDepartmentName] = useState<string>("");
    const [departmentNameError, setDepartmentNameError] = useState<string>("");

    const [searchValue, setSearchValue] = useState("");
    const [status , setStatus] = useState(false)
    const [data, setData] = useState<[] | DepartmentListType[]>([]);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [id, setId] = useState<string | null | undefined>(null);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(20);


    useEffect(() => {
        dispatchResetClientSettingsError()
        dispatchResetClientSettingsSuccessAction()
        dispatchResetDepartmentList()
        dispatchResetClientSettingsStatusCode()
        dispatchResetDepartmentMessage()
        dispatchResetDepartmentUniqueCheckMessage()
        dispatchResetDepartmentUniqueCheckFetching()
       //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (departmentList?.length === 0) {
            setData(departmentList);
        }
        if (offset > 0) {
            setData((prv: any) => [...prv, ...departmentList]);
        } else {
            setData(departmentList);
        }
        //eslint-disable-next-line
    }, [departmentList]);

    useEffect(() => {
        if (token) {
            let finalData: GetDepartmentListPayloadType = {
                token,
                limit,
                offset,
                searchValue,
                client_code:client_code
            };
            if (departmentTotalCount) {
                if (offset < departmentTotalCount){
                    dispatchGetDepartmentList(finalData);
                }
            } else{
                dispatchGetDepartmentList(finalData);
            }
        }
        //eslint-disable-next-line
    }, [offset]);


    useDebounce(
        () => {
            if (searchValue) {
                fetchNewData();
            }
            else{
                let finalData: GetDepartmentListPayloadType = {
                    token,
                    limit,
                    offset,
                    searchValue,
                    client_code:client_code

                };
                dispatchGetDepartmentList(finalData);
            }
        },
        500,
        [searchValue]
    );


// unique check

useDebounce(
    () => {
        if (departmentName?.trim() && token) {
            const finalData = {
                // token,
                // operation: isEdit ? "update" : "add",
                // name: departmentName?departmentName.trim():"",
                // id: isEdit ? id : ""
                token: token,
                client_code:client_code,
                departmentName : departmentName?departmentName.trim():"",
                operation: isEdit ? "update" : "add",
                id: isEdit ? id : ""

            }
            dispatchCheckUniqueDepartmentNameAction(finalData);
        }
    },
    500,
    [departmentName]
)

    useEffect(() => {
        if (!showAddEditDepartmentModal) {
            setIsEdit(false);
        }
    }, [showAddEditDepartmentModal]);

    const handleDepartmentNameChange = (e: any) => {
        setDepartmentName(e.target.value)
    };

    const toggleAddEditDepartmentModal = () => {
                setStatus(false);
        if (!showAddEditDepartmentModal) {
            handleResetData();
        }
       
        setShowAddEditDepartmentModal(!showAddEditDepartmentModal);
    };

    const handleResetData = () => {
        setDepartmentName("");
        setOffset(0)
    };
    const fetchNewData = () => {
        dispatchResetDepartmentList();
        if (token) {
            let finalData = {
                token,
                searchValue,
                limit,
                offset,
                client_code:client_code

            };
            if (offset === 0) {
                dispatchGetDepartmentList(finalData);
            } else {
                setOffset(0);
            }
        }
    };

    const handleSearch = (e: any) => {
        let value = e.target.value;
        setSearchValue(value);

        if (value?.length === 0) {
            let finalData = {
                offset: 0,
                limit,
                token,
                client_code:client_code

            };
            dispatchGetDepartmentList(finalData);
        }
    };
    const handleToogleIsStatus = () => {
        setStatus(!status);
      };
    const handleEditDepartment = (data: any) => {
        dispatchResetDepartmentUniqueCheckMessage();
        dispatchResetDepartmentUniqueCheckFetching();
        setIsEdit(true);
        setShowAddEditDepartmentModal(true);
        setDepartmentName(data?.department_name);
        setStatus(data?.status);
        setId(data?.id);
    };

    const handleAddDepartment = () => {
        setRefresh(!refresh);
        dispatchResetDepartmentList();
        dispatchResetClientSettingsStatusCode();
        dispatchResetDepartmentUniqueCheckMessage();
        dispatchResetDepartmentUniqueCheckFetching();
        if (departmentName?.trim()?.length > 0) {

          if (isEdit) {
            let updateData = {
              token: token,
              client_code:client_code,
              departmentName,
              status:status ? 1 : 0,
              id,
            };
            dispatchUpdateDepartmentAction(updateData);
            handleSuccessMessage("update-department");
          } else {
            let finalAddData = {
              token:token,
              client_code:client_code,
              departmentName,
              status:status ? 1 : 0,
            };
            dispatchAddDepartmentAction(finalAddData);
            handleSuccessMessage("created-department");
            setSearchValue("");
          }
        }
        let finalData = {
            token,
            searchValue,
            limit,
            offset,
            client_code:client_code

        };
        if (offset === 0) {
            dispatchGetDepartmentList(finalData);
        } else {
            setOffset(0);
        }
      };

    const handleSuccessMessage = (type: string) => {
        switch (type) {
            case "created-department":
                return setSuccessMessage("Department has been added successfully!");
            case "update-department":
                return setSuccessMessage("Department Updated Successfully!");
            default:
                return setSuccessMessage("");
        }
    };

    const onScroll = () => {
        if (!fetching) {
            const scrollTop = document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = document.documentElement.clientHeight;

            if (offset < departmentTotalCount && !fetching && Math.ceil(75 / 100 * scrollHeight) <= scrollTop + clientHeight) {
                if (departmentList?.length > 0) {
                    if (!fetching && offset < departmentTotalCount) {
                        setOffset(offset + limit);
                    }
                }
            }
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
        //eslint-disable-next-line
    }, [departmentList]);


    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                );
            } else if (!!error && statusCode !== 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetClientSettingsError();
                        }}
                    />
                );
            }
        }
        if (success === 1 && message?.includes("added successfully!")) {
            dispatchResetDepartmentList();
            dispatchResetClientSettingsSuccessAction();
            dispatchResetDepartmentMessage()
            toast.success(successMessage, {
                duration: 2000,
            });
            if (token) {
                let finalData = {
                    token,
                    limit,
                    offset:0,
                    searchValue,
                    client_code:client_code
                };
                if (offset === 0) {
                    dispatchGetDepartmentList(finalData);
                }
              }
            

        }
        if (success === 1 && message?.includes("updated successfully!")) {
            dispatchResetDepartmentList();
            dispatchResetClientSettingsSuccessAction();
            dispatchResetDepartmentMessage();
            toast.success(successMessage, {
                duration: 2000,
            });

            if (token) {
                let finalData = {
                    token,
                    limit,
                    offset,
                    searchValue,
                    client_code:client_code
                };
                if (offset === 0) {
                    dispatchGetDepartmentList(finalData);
                } 
              }
           
        }

        return false;
    };

    useEffect(() => {
        if (offset === 0) {
            window.scrollTo(0, 0);
        } else {
            window.scrollTo(0, 0);
            setOffset(0);
        }
        //eslint-disable-next-line
    }, [success]);


    return (
        <div className="row">
            <div className="col-md-6 mb-3">
                <CommonHeader title="Department" 
                 company_name={company_name}
                 client_code={client_code}

                />
            </div>
            <div className="col-md-12">
                <div className='jobs-card'>
                    <div className="header">
                        <div className="left-header">
                            <div className="heading">Department List</div>
                            {!fetching &&  <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${departmentTotalCount ? departmentTotalCount : 0} departments found`}</div>}
                        </div>
                        <div className='right-header'>
                            <div className={`${!!departmentList?.length? 'col-md-6':"col-md-10"} position-relative`} >
                                <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                                    <SearchIcon />
                                </span>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e)}
                                    style={{ paddingLeft: "35px" }}
                                    value={searchValue}
                                />
                            </div>
                            { !!departmentList?.length &&( <button className="btn btn-primary" onClick={toggleAddEditDepartmentModal}>
                                + Add Department
                            </button>)}
                        </div>
                    </div>
                    <div>
                        {fetching && offset == 0 ?
                            <TableLoader Rows={10} ColumnPerRow={7} />
                            : departmentList?.length > 0  ? (
                                <DepartmentTable
                                    data={data}
                                    handleEditDepartment={handleEditDepartment}
                                    fetching={fetching}
                                    offset={offset}
                                />
                            ) : <div className="mt-5 pb-5">
                                {!fetching && data?.length === 0 && <EmptyListPage
                                    title="No Department List Found!"
                                    image={EmptyList}
                                    imageWidth="30%"
                                    showAddButton
                                    buttonTitle="+ Add Department "
                                    onButtonClick={toggleAddEditDepartmentModal}
                                />}</div>
                        }
                    </div>
                </div>
            </div >
            {showAddEditDepartmentModal && <AddEditDepartment
                showAddEditDepartmentModal={showAddEditDepartmentModal}
                toggleAddEditDepartmentModal={toggleAddEditDepartmentModal}
                isEdit={isEdit}
                handleDepartmentNameChange={handleDepartmentNameChange}
                departmentName={departmentName}
                status={status}
                handleToogleIsStatus={handleToogleIsStatus}
                handleAddDepartment={handleAddDepartment}
                departmentUniqueCheckFetching={departmentUniqueCheckFetching}
                departmentUniqueCheckMessage={departmentUniqueCheckMessage}
                departmentNameError={departmentNameError}
                

            />}
            {handleErrorModal()}
            <Toaster/>
        </div >
    );
};

const mapStateToProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.clientSettings.fetching,
    success: state.clientSettings.success,
    error: state.clientSettings.error,
    statusCode: state.clientSettings.statusCode,
    message:state.clientSettings.message,
    departmentList: state.clientSettings.departmentList,
    departmentTotalCount: state.clientSettings.departmentTotalCount,
    departmentUniqueCheckFetching:state.clientSettings.departmentUniqueCheckFetching,
    departmentUniqueCheckMessage:state.clientSettings.departmentUniqueCheckMessage
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
    dispatchResetClientSettingsSuccessAction: () =>
      dispatch(resetClientSettingsSuccess()),
    dispatchGetDepartmentList: (data: GetDepartmentListPayloadType) => {
        dispatch(getDepartmentListAction(data));
    },
    dispatchCheckUniqueDepartmentNameAction: (data: UniqueDepartmentNamePayloadType) => dispatch(checkUniqueDepartmentNameAction(data)),

    dispatchAddDepartmentAction: (data: CreateDepartmentPayloadType) =>
    dispatch(createDepartmentAction(data)),
    dispatchUpdateDepartmentAction: (data: UpdateDepartmentPayloadType) =>
    dispatch(updateDepartmentAction(data)),
    dispatchResetDepartmentMessage:()=>dispatch(resetDepartmentMessage()),
    dispatchResetDepartmentUniqueCheckMessage: () => dispatch(resetDepartmentUniqueCheckMessage()),
    dispatchResetDepartmentUniqueCheckFetching: () => dispatch(resetDepartmentUniqueCheckFetching()),
    dispatchResetDepartmentList:()=>dispatch(resetDepartmentList()),
    dispatchResetClientSettingsStatusCode:()=> dispatch(resetClientSettingsStatusCode())
 
});

export default connect(mapStateToProps, mapDispatchToProps)(Department);

